module.exports = __webpack_public_path__ + "img/ztjt.1bf9e217.png";